import SetEndUserPage from './SetEndUserPage';

export default SetEndUserPage;
